export default __webpack_public_path__ + "static/media/404.18d3dcf7.png";